import React, { useContext } from 'react';
import { LassieContext } from '../../../context/LassieProvider';
import { useNavigate } from "react-router-dom";
import WindfarmList from "../../../components/lassie-specific/WindfarmList";
import TurbineAnimation from '../../../components/turbine-animation/TurbineAnimation';
import './lightning-page-home.css';


export default function LightningHomePage() {
    const navigate = useNavigate();
    const { windfarms, loading } = useContext(LassieContext);

    if (loading) {
        return (
            <div className='lightning-page-home'>
                <div className='bg-img' />
                <div className='overlay loading'>
                <TurbineAnimation overlayClassname="darker-overlay" />
                </div>
            </div>
        );
    }

    if (windfarms && windfarms.length === 0) {
        return (
            <div className='lightning-page-home'>
                <div className='bg-img' />
                <div className='lightning-popup'>
                    <h2>Windpowerlab's Lightning Monitoring system: LASSIE</h2>
                    <p>Contact us for a demo</p>
                    <button className='popup-btn' onClick={() => navigate('/')} >Back to Wind Diagnostics</button>
                </div>
            </div>
        );
    }

    return (
        <div className='lightning-page-home'>
            <div className='bg-img' />
            <div className='lightning-home-content'>
                <WindfarmList />
            </div>
        </div>
    );
}
